import "core-js/modules/es.array.push.js";
import { captureException } from "@sentry/vue";
export default {
  name: "AdminHeader",
  data() {
    return {
      navigationDrawerOpen: false
    };
  },
  methods: {
    logout() {
      this.$http.post('signOut').then(() => {
        this.$store.dispatch('authLogout').then(() => {
          this.$router.push({
            path: '/login'
          });
        });
      }).catch(error => captureException(error));
    }
  }
};